import { useTranslation } from 'react-i18next';

export type ProductCategoryStatus = keyof ReturnType<typeof useProductCategoryStatus>;

export const PRODUCT_CATEGORY_STATUS = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
};

export const useProductCategoryStatus = () => {
    const { t } = useTranslation();
    return {
        ACTIVE: t('STATUS.ACTIVE'),
        INACTIVE: t('STATUS.INACTIVE'),
    };
};

export const PRODUCT_CATEGORY_STATUS_COLOR: Record<
    string,
    'success' | 'error' | 'default' | 'primary' | 'secondary' | 'info' | 'warning'
> = {
    ACTIVE: 'success',
    INACTIVE: 'error',
};

export const useFilterSelectOptions = () => {
    const productCategoryStatus = useProductCategoryStatus();

    return Object.keys(productCategoryStatus).map((status) => ({
        value: status,
        label: productCategoryStatus[status],
    }));
};
